import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators';
import { LocalStorageKey } from '..';
import { Role } from '../login';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor( private router: Router,
    private authService: AuthService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // TODO: check user login
    if (!this.authService.IsAuthenticate) {
      this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname } });
      return false;
    }
    return this.authService.getCurrentUser().pipe(map(user => {
      // Update user in storage
      localStorage.setItem(LocalStorageKey.CurrentUser, JSON.stringify(user));
      const roles: Array<string> = next.data.roles;
      if (user.roles.find(r => roles.indexOf(r) > -1)) {
        return true;
      }
      this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname } });
    }, error => {
      this.authService.clearToken();
      this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname } });
    }));
  }
}
